export const feedForwardArr = [
  {
    name: "Target",
    type: "dropdown",
    data: [
      "Pregnancies",
      "Glucose",
      "BloodPressure",
      "SkinThickness",
      "Insulin",
      "BMI",
      "DiabetesPedigreeFunction",
      "Age",
      "Outcome",
      "None",
    ],
  },
  {
    name: "N-layers",
    type: "input",
    data: ["2"],
  },
  {
    name: "Input dimension",
    type: "text",
    data: ["8"],
  },
  {
    name: "Activation",
    type: "dropdown",
    data: ["linear", "poly", "rbf", "sigmoid", "precomputed"],
  },
  {
    name: "Learning rate",
    type: "dropdown",
    data: [0.001, 0.01, 0.1, 1, 10],
  },
  {
    name: "Regularization",
    type: "dropdown",
    data: ["None", "L1", "L2"],
  },
  {
    name: "Metrics",
    type: "dropdown",
    data: ["Accuracy", "mae", "mse"],
  },
];

export const LSTMArr = [
  {
    name: "Target",
    type: "dropdown",
    data: [
      "Pregnancies",
      "Glucose",
      "BloodPressure",
      "SkinThickness",
      "Insulin",
      "BMI",
      "DiabetesPedigreeFunction",
      "Age",
      "Outcome",
      "None",
    ],
  },
  {
    name: "N-layers",
    type: "input",
    data: ["2"],
  },
  {
    name: "Input dimension",
    type: "text",
    data: ["8"],
  },
  {
    name: "Output dimension",
    type: "text",
    data: ["2"],
  },

  {
    name: "Activation",
    type: "dropdown",
    data: ["linear", "poly", "rbf", "sigmoid", "precomputed"],
  },
  {
    name: "Recurrent activation",
    type: "dropdown",
    data: ["linear", "poly", "rbf", "sigmoid", "precomputed"],
  },
  {
    name: "Return Sequences",
    type: "dropdown",
    data: ["True", "False"],
  },
];
